import portalImg from '@/assets/icons/checkliste.svg';
import beratungImg from '@/assets/icons/beratungstermin.svg';
import onSiteImg from '@/assets/icons/termin_vor_ort.svg';

export const successCardsDataOnline = [
    {
        imageSrc: portalImg,
        imageAlt: '',
        headline: '1. Ergänzung der Gebäudedaten',
        text: 'Sie haben per E-Mail einen Link mit weiteren Fragen von uns erhalten. Die Daten helfen uns bei der Planung. Bei Bedarf unterstützen wir Sie beim Ausfüllen dieses Fragebogens. Spätestens am nächsten Werktag nach Ihrer Anfrage melden wir uns telefonisch.',
    },
    {
        imageSrc: beratungImg,
        imageAlt: '',
        headline: '2. Photovoltaik-Beratungstermin',
        text: 'Wir prüfen Ihre Gebäudedaten für eine individuelle Planung Ihrer PV-Anlage. In einem Online-Termin stellen wir Ihnen Ihr Angebot vor und besprechen alle weiteren Fragen.',
    },

];

export const successCardsDataOnSite = [
    {
        imageSrc: onSiteImg,
        imageAlt: '',
        headline: 'Vor-Ort-Termin und Beratung',
        text: 'Wir melden uns telefonisch bei Ihnen, um einen Termin zu vereinbaren.<br />Beim Vor-Ort-Termin werden die Voraussetzungen Ihres Hauses überprüft. Anschließend wird direkt eine individuelle Planung und ein kostenloses Angebot für Sie erstellt.',
    },
];